<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// Components
import Asd20AppHeader from '@asd20/ui/src/components/organisms/Asd20AppHeader'
import Asd20DistrictLogo from '@asd20/ui/src/components/atoms/Asd20DistrictLogo'
import Asd20Modal from '@asd20/ui/src/components/molecules/Asd20Modal'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20TourGuide from '@asd20/ui/src/components/organisms/Asd20TourGuide'

export default {
  name: 'App',
  components: { Asd20AppHeader, Asd20DistrictLogo, Asd20Modal, Asd20Viewport, Asd20TourGuide },
}
</script>

<style lang="scss">
#app {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;

  .asd20-app-template__sidebar-title {
    font-size: 1rem;
    line-height: 1;
    margin: 0;
    align-items: center;
  }
}
</style>
